// extracted by css-extract-rspack-plugin
export default {"profileImage":"styles-module__profileImage--aPalM"};